// Loose relationships are directional: each row stores the label the OTHER
// profile shows. Symmetric ties mirror themselves; asymmetric ones suggest
// both directions. First entry is the auto-prefill.
const RELATIONSHIP_INVERSES: Record<string, string[]> = {
  friend: ["Friend"],
  sibling: ["Sibling", "Brother", "Sister"],
  "baby mama": ["Baby daddy", "Baby mama"],
  "baby daddy": ["Baby mama", "Baby daddy"],
  partner: ["Partner"],
  parent: ["Child", "Son", "Daughter"],
  child: ["Parent", "Mother", "Father"],
  cousin: ["Cousin"],
  "case buddy": ["Case buddy"],
  roommate: ["Roommate"],
  grandparent: ["Grandchild"],
  aunt: ["Niece", "Nephew"],
  uncle: ["Niece", "Nephew"],
};

export function inverseSuggestionsFor(label: string): string[] {
  return RELATIONSHIP_INVERSES[label.trim().toLowerCase()] ?? [];
}
